import "./edit-contract.scss";
import { FaChevronLeft } from "react-icons/fa6";
import { FormProvider } from "react-hook-form";
import { ConfirmDialog } from "primereact/confirmdialog";

import SkeletonList from "@shared/ui/skeleton-list/skeleton-list";
import ErrorSection from "@shared/ui/error-section/error-section";
import HeaderContent from "@shared/ui/header-content/header-content";
import HeaderButton from "@shared/ui/header-button/header-button";

import { useEditContract } from "./edit-contract.hook";
import PrintWaiver from "../print-waiver/print-waiver";
import { useState } from "react";
import { Outlet } from "react-router-dom";
import { Dialog } from "primereact/dialog";
import { GetContractDto } from "@api/api";
import { GetWaiverModel } from "@factory/model/query-model-waiver";
import { Menubar } from "primereact/menubar";

export function EditContract() {
  const {
    isLoading,
    contractError,
    formMethod,
    actions,
    signatureBlob,
    printWaiverRef,
    session,
    contractData,
    handleBack,
    handleAction,
    menuItems,
    isExactContractRoute,
  } = useEditContract();
  const [visibleWaiverPreview, setVisibleWaiverPreview] = useState(false);
  const [previewContract, setPreviewContract] = useState<
    GetContractDto | undefined
  >(undefined);
  const handleSetWaiver = (waiver: GetWaiverModel) => {
    const previewContract = {
      ...contractData,
      waiver: waiver.code,
      waiver_description: waiver.description,
      waiver_name: waiver.name,
      waiver_font_size: waiver.font_size,
      waiver_sub_title: waiver.sub_title,
    } as GetContractDto;

    setPreviewContract(previewContract);
    setVisibleWaiverPreview(true);
  };

  const title = <h1>Edit Contract</h1>;
  const displayLoading = (
    <div className="card">
      <SkeletonList count={4} />
    </div>
  );
  const displayError = (
    <div className="card">
      <ErrorSection
        title="No Data"
        message="No data found in selected record. Please try again."
      />
    </div>
  );

  const contextValue = {
    signatureBlob,
    handleWaiverPreview: handleSetWaiver,
  };

  const mainContent = (
    <section className="grid grid-cols-1 gap-2 mb-4">
      <Menubar model={menuItems} />

      <div className="mt-4">
        <Outlet context={contextValue} />
      </div>
    </section>
  );

  const printWaiver = (
    <div style={{ display: "none" }}>
      <div ref={printWaiverRef}>
        {contractData ? (
          <PrintWaiver
            title={contractData.waiver_name || ""}
            subTitle={contractData.waiver_sub_title}
            fontSize={contractData.font_size}
            session={session ?? 0}
            patient={`${contractData.first_name} ${contractData.last_name}`}
            doctor={`${contractData.person_first_name} ${contractData.person_last_name}`}
            service={contractData.service_name}
            waiverText={contractData.waiver_description || ""}
            signature={signatureBlob}
          />
        ) : null}
      </div>
    </div>
  );
  const printPreviewWaiver = (
    <Dialog
      header="Waiver Preview"
      visible={visibleWaiverPreview}
      style={{ width: "50vw" }}
      onHide={() => {
        if (!visibleWaiverPreview) return;
        setVisibleWaiverPreview(false);
      }}
    >
      {previewContract ? (
        <PrintWaiver
          title={previewContract.waiver_name || ""}
          subTitle={previewContract.waiver_sub_title}
          fontSize={previewContract.font_size}
          session={session ?? 0}
          patient={`${previewContract.first_name} ${previewContract.last_name}`}
          doctor={`${previewContract.person_first_name} ${previewContract.person_last_name}`}
          service={previewContract.service_name}
          waiverText={previewContract.waiver_description || ""}
          signature={signatureBlob}
        />
      ) : null}
    </Dialog>
  );

  return (
    <div id="EditContract" className="contract">
      <HeaderContent
        title={title}
        backIcon={<FaChevronLeft />}
        onBack={() => handleBack()}
      >
        {isExactContractRoute && (
          <HeaderButton actions={actions} onAction={handleAction} />
        )}
      </HeaderContent>

      <section className="p-7">
        {printWaiver}
        {printPreviewWaiver}
        <ConfirmDialog />
        <FormProvider {...formMethod}>
          {isLoading && displayLoading}
          {contractError && !isLoading && displayError}
          {!isLoading ? mainContent : null}
        </FormProvider>
      </section>
    </div>
  );
}

export default EditContract;
